import React, { useState, useEffect } from 'react';
import styles from '../Writes.module.scss';
import {
    ASSIGN_BOOK_TEMPLATE_TO_CLASS,
    ASSIGN_BOOK_TEMPLATE_TO_GROUP,
} from '../services/graphql';
import { useMutation } from '@apollo/react-hooks';
import Output from '../../../components/EditorJsOutput';
import FormErrors from '../../../components/FormErrors';

import { Users, ArrowLeft } from 'react-feather';
import { useNavigate } from '@reach/router';

const ConfigureBookTemplates = ({
    selectedClass,
    selectedGroup,
    selectedCategory,
    selectedSubcategory,
    navigateBack,
}) => {
    const navigate = useNavigate();

    const renderChapterContent = (starter) => {
        try {
            return JSON.parse(starter.content);
        } catch (e) {
            return {
                blocks: [
                    {
                        type: 'paragraph',
                        data: {
                            text: starter.content,
                        },
                    },
                ],
            };
        }
    };

    const [selectedStarter, setSelectedStarter] = useState(null);
    const [chapters, setChapters] = useState('');
    const [mutationErrors, setMutationErrors] = useState([]);

    const chaptersMap = Array.from(Array(10).keys(), (n) => n + 1);

    const [assignBookTemplateToClass, { loading: assigning }] = useMutation(
        ASSIGN_BOOK_TEMPLATE_TO_CLASS,
        {
            update: (_, { data }) => {
                if (data?.assignBookTemplateToClass?.errors?.length > 0) {
                    setMutationErrors(data.assignBookTemplateToClass.errors);
                    return;
                }
                if (data?.assignBookTemplateToClass?.classBook?.id) {
                    navigate(
                        `/book/${data.assignBookTemplateToClass.classBook.id}`
                    );
                }
            },
        }
    );

    const [assignBookTemplateToGroup, { loading: assigningToGroup }] =
        useMutation(ASSIGN_BOOK_TEMPLATE_TO_GROUP, {
            update: (_, { data }) => {
                if (data?.assignBookTemplateToGroup?.errors?.length > 0) {
                    setMutationErrors(data.assignBookTemplateToGroup.errors);
                    return;
                }
                if (data?.assignBookTemplateToGroup?.classBook?.id) {
                    navigate(
                        `/book/${data.assignBookTemplateToGroup.classBook.id}`
                    );
                }
            },
        });

    useEffect(() => {
        if (!selectedCategory && (selectedClass || selectedGroup)) {
            navigate(
                `/startWrite/selectCategory/${
                    selectedClass ? selectedClass.id : selectedGroup.id
                }`
            );
        }
    }, [selectedCategory, selectedClass, selectedGroup]);

    if (!selectedSubcategory) {
        return null;
    }

    if (selectedSubcategory?.bookTemplates) {
        const { bookTemplates } = selectedSubcategory;
        return (
            <>
                <div className='page-header'>
                    <div className='page-header__content'>
                        <div className='page-header__content__inner'>
                            <h2 className='page-header__content__title'>
                                <Users />
                                {selectedClass
                                    ? selectedClass.name
                                    : selectedGroup.id}
                            </h2>
                        </div>
                    </div>
                    <div className='page-header__actions'>
                        <button
                            onClick={navigateBack}
                            className='btn-reset u-display-flex u-align-center u-text-dark'
                        >
                            <ArrowLeft className='u-m-right-1' /> Back
                        </button>
                    </div>
                </div>

                <div className={styles.selector}>
                    <div className={styles.selectorSite}>
                        <div className='panelLight2 u-m-base-3'>
                            <div className={styles.categorySubcategoryLabels}>
                                <p>
                                    <span
                                        style={{
                                            color: selectedCategory.textColor
                                                ? selectedCategory.textColor
                                                : '',
                                            backgroundColor:
                                                selectedCategory.backgroundColor
                                                    ? selectedCategory.backgroundColor
                                                    : '',
                                        }}
                                        className='label'
                                    >
                                        {selectedCategory.name}
                                    </span>
                                </p>
                                <p>
                                    <span
                                        style={{
                                            color: selectedSubcategory.textColor
                                                ? selectedSubcategory.textColor
                                                : '',
                                            backgroundColor:
                                                selectedSubcategory.backgroundColor
                                                    ? selectedSubcategory.backgroundColor
                                                    : '',
                                        }}
                                        className='label'
                                    >
                                        {selectedSubcategory.name}
                                    </span>
                                </p>
                            </div>

                            <h2 className='u-m-base-2'>Select a starter</h2>
                            <ul>
                                {bookTemplates.map((starter) => (
                                    <li
                                        key={starter.id}
                                        className={`${styles.starterItem} ${
                                            selectedStarter?.id === starter.id
                                                ? styles.starterItemSelected
                                                : ''
                                        }`}
                                        onClick={() =>
                                            setSelectedStarter(starter)
                                        }
                                    >
                                        {starter.name}
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className='panelLight2'>
                            <h2>Book settings</h2>
                            <p className='u-m-base-2'>Number of chapters</p>
                            <select
                                value={chapters}
                                onChange={(e) => setChapters(e.target.value)}
                                className='basic-form__text-select'
                            >
                                <option value=''>Please select</option>
                                {chaptersMap.map((el) => (
                                    <option key={`opt-${el}`} value={el}>
                                        {el}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className={styles.selectorMain}>
                        <div className='panelLight2'>
                            {selectedStarter ? (
                                <div>
                                    <div
                                        className={`${styles.selectedStarterHead} u-m-base-3`}
                                    >
                                        <p
                                            className={`${styles.starterItem} ${styles.starterItemSelected} u-m-base-0`}
                                        >
                                            {selectedStarter.name}
                                        </p>
                                        <button
                                            onClick={() => {
                                                if (selectedClass) {
                                                    assignBookTemplateToClass({
                                                        variables: {
                                                            studentsClassId:
                                                                selectedClass.id,
                                                            bookTemplateId:
                                                                selectedStarter.id,
                                                            numberOfChapters:
                                                                +chapters,
                                                        },
                                                    });
                                                } else {
                                                    assignBookTemplateToGroup({
                                                        variables: {
                                                            groupId:
                                                                selectedGroup.id,
                                                            bookTemplateId:
                                                                selectedStarter.id,
                                                            numberOfChapters:
                                                                +chapters,
                                                        },
                                                    });
                                                }
                                            }}
                                            className='btn btn-primary'
                                            disabled={
                                                !chapters ||
                                                assigning ||
                                                assigningToGroup
                                            }
                                        >
                                            Select
                                        </button>
                                    </div>
                                    {mutationErrors && (
                                        <FormErrors errors={mutationErrors} />
                                    )}
                                    {selectedStarter.chapters.length > 0 && (
                                        <Output
                                            data={renderChapterContent(
                                                selectedStarter.chapters[0]
                                            )}
                                        />
                                    )}
                                </div>
                            ) : (
                                <p>Select a story start from the left</p>
                            )}
                        </div>
                    </div>
                </div>
            </>
        );
    }
    return null;
};

export default ConfigureBookTemplates;
